var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{staticClass:"settings",style:(_vm.settingsStyle),on:{"reset":_vm.reset,"update":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }